<template>
  <div class="manual-container">
    <div class="manual-main">
      <div class="manual-main-top">
        <el-breadcrumb>
          <el-breadcrumb-item>
            <a :href="baseLink">首页</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item> {{ stageItem.name }}{{ subjectItem.name }} </el-breadcrumb-item>
          <el-breadcrumb-item>组卷</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="manual-main-left">
        <div class="manual-main-left-top">
          <span v-for="item in selectType" :key="item.value" :class="selectIndex == item.value ? 'active' : ''" @click="toggleSelectType(item.value)">
            <span>{{ item.label }}</span>
          </span>
        </div>
        <div class="manual-main-left-middle" v-show="selectIndex == '0'">
          <el-popover placement="bottom" width="252" trigger="click" v-model="visible" popper-class="select-type-popover">
            <div class="select-type-slot">
              <el-form :model="selectTypeFromModel" ref="selectTypeFrom" label-position="left" label-width="50px" size="small">
                <el-form-item label="版本：" v-if="selectIndex == '0'">
                  <el-select v-model="selectTypeFromModel.versionId" placeholder="版本" @change="getPaperBasicData">
                    <el-option v-for="item in versionData" :label="item.name" :value="item.id" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="册别：" v-if="selectIndex == '0'">
                  <el-select v-model="selectTypeFromModel.bookTypeId" placeholder="册别" @change="getPaperBasicData">
                    <el-option v-for="item in bookTypeData" :label="item.name" :value="item.id" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="select-type-slot-btnGroup">
                  <el-button type="primary" size="medium" @click="filterByChapter">确定</el-button>
                  <el-button size="medium" @click="visible = false">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
            <span slot="reference">
              <span class="selected-type-text" v-if="selectTypeText">
                <span :title="selectTypeText">{{ selectTypeText }}</span
                >&emsp;<i :class="visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
              </span>
            </span>
          </el-popover>
        </div>
        <div class="manual-main-left-bottom">
          <zero-tree v-model="keys" v-if="treeData.length > 0" :treeData="treeData" />
          <div class="manual-main-left-bottom-empty" v-else>暂无数据</div>
        </div>
      </div>
      <div class="manual-main-right">
        <div class="manual-main-right-top">
          <div class="manual-main-right-top-item">
            <span>题型：</span>
            <ul class="manual-main-right-top-list" v-if="exerciseType.length > 0" :class="isMore ? '' : 'fh'">
              <li v-for="item in exerciseType" :key="item.id" :class="exerciseTypeIndex == item.id ? 'active' : ''" @click="exerciseTypeFilter(item)">
                {{ item.label }}
              </li>
            </ul>
            <span v-if="exerciseType.length > 9" @click="toggleMore"
              ><a href="javascript:;">更多<i :class="isMore ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></a
            ></span>
          </div>
          <div class="manual-main-right-top-item">
            <span>类型：</span>
            <ul class="manual-main-right-top-list" v-if="exerciseBigType.length > 0">
              <li v-for="item in exerciseBigType" :key="item.id" :class="exerciseBigTypeIndex == item.id ? 'active' : ''" @click="exerciseBigTypeFilter(item)">
                {{ item.label }}
              </li>
            </ul>
          </div>
          <div class="manual-main-right-top-item">
            <span>难度：</span>
            <ul class="manual-main-right-top-list" v-if="exerciseDifficult.length > 0">
              <li v-for="item in exerciseDifficult" :key="item.id" :class="exerciseDifficultIndex == item.id ? 'active' : ''" @click="exerciseDifficultFilter(item)">
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
        <div class="manual-main-right-middle">
          <div class="manual-main-right-size-group">
            <span v-for="item in exerciseSize" :key="item.value" :class="exerciseSizeIndex == item.value ? 'active' : ''" @click="toggleFilterSize(item)">{{ item.label }} <i class="iconfont icon-xiayi"></i></span>
          </div>
          <div class="manual-main-right-totalSize">共 {{ total }} 条结果</div>
        </div>
        <div class="manual-main-right-bottom">
          <div v-if="loadingFlag" class="myLoading">
            <i class="el-icon-loading large-loading"></i>
          </div>
          <div class="manual-main-right-bottom-noEmpty" v-if="exerciseList.length > 0">
            <!-- 有数据 -->
            <!-- 试题组件 -->
            <question :questionList="exerciseList" :stageId="selectTypeFromModel.stageId" :subjectId="selectTypeFromModel.subjectId" :basketPaperId="shoppingCartList.paper_id" :basketTotal="shoppingCartList.total" @refreshExercisesList="refreshExercisesList" @refreshCartList="refreshCartList"></question>
            <!-- 分页 -->
            <div class="manual-main-right-pageWrap">
              <pagination name="listPage" :total="total" :current-page="currentPage" :pageSize="10" @change="currentPageChange"></pagination>
            </div>
          </div>
          <!-- 无数据 -->
          <div class="manual-main-right-empty" v-else>
            <p><i class="iconfont icon-wushuju"></i></p>
            <p>筛选无结果，换个条件试试吧</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 试题篮组件 -->
    <shopping-cart :shoppingCartList="shoppingCartList" @refreshExercisesList="refreshExercisesList"></shopping-cart>
  </div>
</template>

<script>
var that
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import shoppingCart from '@/components/shoppingCar.vue'
import pagination from '@/components/pagination.vue'
import question from '@/components/question.vue'
import { showLoading, hideLoading } from '../utils/loading.js'
import * as util from '../utils/util.js'
import { paperBasicData, paperChapterData, paperKnowledgesData, questionOptions, shoppingCartList, questionList } from '@/api/manual'
export default {
  name: 'manual',
  data() {
    return {
      selectIndex: '1', // 当前选中的索引
      selectType: [{ label: '按章节选题', value: '0' }, { label: '按知识点选题', value: '1' }],
      visible: false, // 点击下拉选择表单
      versionData: [], // 版本data
      bookTypeData: [], // 册别data
      selectedTextArr: [], // 选中的需要筛选的字段数组
      selectTypeText: '', // 选中的需要筛选的字段拼接
      selectTypeFromModel: {
        stageId: '',
        subjectId: '',
        versionId: '',
        bookTypeId: '',
      },
      stageItem: {
        name: '小学',
        id: 1,
      },
      subjectItem: {
        name: '语文',
        id: '2',
      },
      initFlag: true, // 用于初始化事件判断

      keys: [], // 选中的节点id
      treeData: [], // 树章节列表

      exerciseTypeIndex: 0,
      exerciseType: [],
      exerciseBigTypeIndex: 0,
      exerciseBigType: [],
      exerciseDifficultIndex: 0,
      exerciseDifficult: [],
      isMore: true, // 更多按钮

      exerciseSizeIndex: 'time',
      exerciseSize: [
        // 试题次数
        { label: '最新', value: 'time' },
        { label: '组卷次数', value: 'used_num' },
      ],

      /* 试题列表 */
      exerciseList: [], // 后台返回当前页十条的试题数据传入子组件
      currentPage: 1, // 当前页码
      total: 0, // 总数

      shoppingCartList: {
        // 试题篮列表
        data: [],
        paper_id: '',
        total: 0,
      },
      loadingFlag: false,
      optsParentWidth: 890, // 选项父容器的宽度
    }
  },
  computed: {
    ...mapGetters(['baseLink', 'userInfo']),
  },
  components: {
    shoppingCart,
    question,
    pagination,
  },
  watch: {
    keys(curVal, oldVal) {
      that.exerciseTypeIndex = 0
      that.exerciseDifficultIndex = 0
      that.exerciseBigTypeIndex = 0
      // 章节、知识点筛选
      that.currentPage = 1
      window.scrollTo(0, 0)
      if (curVal[0]) {
        that.editRouterQuery(curVal[0])
      }
      that.getQuestionsList(that.currentPage)
    },
    selectedTextArr: {
      // 切换知识点和章节
      handler(newValue, oldValue) {
        if (newValue.length != oldValue.length) {
          that.composeStr()
        }
      },
      deep: true,
    },
  },
  created() {
    that = this
    let $routeQuery = that.$route.query,
      routeQueryKeys = Object.keys(that.$route.query)
    if (routeQueryKeys.length) {
      routeQueryKeys.forEach(item => {
        console.log(item)
        let routeQueryValue = $routeQuery[item]
        switch (item) {
          case 'stage_id':
            that.selectTypeFromModel.stageId = routeQueryValue
            break
          case 'subject_id':
            that.selectTypeFromModel.subjectId = routeQueryValue
            break
          case 'version_id':
            that.selectTypeFromModel.versionId = routeQueryValue
            break
          case 'book_id':
            that.selectTypeFromModel.bookTypeId = routeQueryValue
            break
          case 'chapter_id':
            that.selectIndex = '0'
            break
          case 'knowledge_id':
            that.selectIndex = '1'
            break
        }
      })
    } else {
      if (Cookies.get('filters')) {
        let filters = Cookies.get('filters').split(',')
        that.selectTypeFromModel = {
          stageId: filters[0],
          subjectId: filters[1],
          versionId: filters[2] ? filters[2] : '',
          bookTypeId: filters[3] ? filters[3] : '',
        }
      }
    }
    that.getPaperBasicData()
  },
  methods: {
    /* ------------------------------------------- 功能交互 ------------------------------------------- */
    toggleSelectType(i) {
      // toggle按章节/知识点
      that.currentPage = 1
      that.selectIndex = i
      that.exerciseTypeIndex = 0
      that.exerciseDifficultIndex = 0
      that.exerciseBigTypeIndex = 0
      that.editRouterQuery('') // 清空地址栏知识点和章节id
      that.keys = []
      that.getPaperBasicData()
      if (that.selectIndex == '0') {
        that.getPaperChapterData()
      } else {
        that.getPaperKnowledgesData()
      }
      // that.getQuestionsList(that.currentPage)
    },
    exerciseTypeFilter(item) {
      // toggle题型
      that.exerciseTypeIndex = item.id
      that.currentPage = 1
      that.getQuestionsList(that.currentPage)
    },
    exerciseBigTypeFilter(item) {
      // toggle题类
      that.exerciseBigTypeIndex = item.id
      that.currentPage = 1
      that.getQuestionsList(that.currentPage)
    },
    exerciseDifficultFilter(item) {
      // toggle难度
      that.exerciseDifficultIndex = item.id
      that.currentPage = 1
      that.getQuestionsList(that.currentPage)
    },
    toggleMore() {
      // 切换更多
      that.isMore = !that.isMore
    },
    toggleFilterSize(item) {
      // toggle最新和下载次数
      that.exerciseSizeIndex = item.value
      that.currentPage = 1
      that.getQuestionsList(that.currentPage)
    },
    getTreeNodeById(Data, id) {
      // 根据id查询树节点
      var Deep, T, F
      for (F = Data.length; F; ) {
        T = Data[--F]
        if (id == T.id) {
          that.$set(T, 'open', true)
          that.$set(T, 'checked', true)
          return T
        }
        if (T.children) {
          Deep = that.getTreeNodeById(T.children, id)
          if (Deep) {
            that.$set(T, 'open', true)
            return Deep
          }
        }
      }
    },
    composeStr() {
      // 组合章节字符
      that.selectTypeText = that.selectedTextArr.join('•')
    },
    currentPageChange(page) {
      that.currentPage = page.curPage
      window.scrollTo(0, 0)
      that.getQuestionsList(that.currentPage)
    },
    editRouterQuery(id) {
      // 动态修改路由（地址栏）参数，带参数去登录跳转地址
      let query = that.$route.query
      query.stage_id = that.selectTypeFromModel.stageId
      query.subject_id = that.selectTypeFromModel.subjectId
      let newQuery = JSON.parse(JSON.stringify(query))
      if (that.selectIndex == '0') {
        delete newQuery.knowledge_id
        newQuery.chapter_id = id
      } else {
        delete newQuery.chapter_id
        newQuery.knowledge_id = id
      }
      that.$router.push({
        query: newQuery,
      }).catch(err => {
          // console.log('输出报错',err)
      })
    },

    /* ------------------------------------------- 请求接口 ------------------------------------------- */
    getPaperBasicData() {
      // 获取基础数据
      let bodyData = {
        stage_id: that.selectTypeFromModel.stageId ? that.selectTypeFromModel.stageId : '',
        subject_id: that.selectTypeFromModel.subjectId ? that.selectTypeFromModel.subjectId : '',
        version_id: that.selectTypeFromModel.versionId ? that.selectTypeFromModel.versionId : '',
        book_id: that.selectTypeFromModel.bookTypeId ? that.selectTypeFromModel.bookTypeId : '',
      }
      return new Promise((resolve, reject) => {
        paperBasicData(bodyData).then(res => {
          if (res.code === 200) {
            that.versionData = res.data.versions
            that.bookTypeData = res.data.books
            that.selectedTextArr = []
            // 学段
            that.stageItem = res.data.stages.find(item => {
              return item.choose == 1
            })
            that.selectTypeFromModel.stageId = that.stageItem.id
            // 学科
            that.subjectItem = res.data.subjects.find(item => {
              return item.choose == 1
            })
            that.selectTypeFromModel.subjectId = that.subjectItem.id
            // 版本
            if (that.versionData.length > 0) {
              let versionItem = that.versionData.find(item => {
                return item.choose == 1
              })
              that.selectTypeFromModel.versionId = versionItem.id
              that.selectedTextArr.push(versionItem.name)
            } else {
              that.selectTypeFromModel.versionId = ''
            }
            // 册别
            if (that.bookTypeData.length > 0) {
              let bookItem = that.bookTypeData.find(item => {
                return item.choose == 1
              })
              that.selectTypeFromModel.bookTypeId = bookItem.id
              that.selectedTextArr.push(bookItem.name)
            } else {
              that.selectTypeFromModel.bookTypeId = ''
            }
            // 初始化第一次进来
            if (that.initFlag) {
              that.composeStr()
              that.getQuestionOption() // 获取试题选项
              // 获取树列表
              if (that.selectIndex == '0') {
                that.getPaperChapterData()
              } else {
                that.getPaperKnowledgesData()
              }
              // 试题，试题库页面跳转过来，知识点id是空的;如果不是空的keys数组会发生变化自动就会刷新试题列表
              if (!(that.$route.query.stage_id && that.$route.query.subject_id && that.$route.query.knowledge_id)) {
                that.getQuestionsList(that.currentPage)
              }
              that.getShoppingCartList() // 试题篮列表
              that.initFlag = false
            }
          }
        })
      })
    },
    getPaperChapterData() {
      // 获取章节树列表
      if (that.selectTypeFromModel.bookTypeId) {
        // 不存在册别id就不掉接口，4/25的优化
        showLoading('.manual-main-left-bottom')
        let data = {
          book_id: that.selectTypeFromModel.bookTypeId,
        }
        return new Promise((resolve, reject) => {
          paperChapterData(data).then(res => {
            hideLoading()
            if (res.code === 200) {
              that.treeData = res.data
              if (that.$route.query.stage_id && that.$route.query.chapter_id) {
                // 相关知识点跳过来
                that.keys = []
                that.keys.push(Number(that.$route.query.chapter_id))
                that.getTreeNodeById(that.treeData, that.$route.query.chapter_id)
              } else {
                that.treeData.forEach((item, index) => {
                  if (index == 0) {
                    that.$set(item, 'open', true)
                  }
                })
              }
            }
          })
        })
      } else {
        that.treeData = []
      }
    },
    getPaperKnowledgesData() {
      // 获取知识点树列表
      showLoading('.manual-main-left-bottom')
      let data = {
        stage_id: that.selectTypeFromModel.stageId,
        subject_id: that.selectTypeFromModel.subjectId,
      }
      return new Promise((resolve, reject) => {
        paperKnowledgesData(data).then(res => {
          hideLoading()
          if (res.code === 200) {
            that.treeData = res.data
            if (that.$route.query.stage_id && that.$route.query.knowledge_id) {
              // 相关知识点跳过来
              that.keys = []
              that.keys.push(Number(that.$route.query.knowledge_id))
              that.getTreeNodeById(that.treeData, that.$route.query.knowledge_id)
            } else {
              // 默认展开第一个
              that.treeData.forEach((item, index) => {
                if (index == 0) {
                  that.$set(item, 'open', true)
                }
              })
            }
          }
        })
      })
    },
    filterByChapter() {
      // 根据章节筛选
      that.exerciseTypeIndex = 0
      that.exerciseDifficultIndex = 0
      that.exerciseBigTypeIndex = 0
      that.keys = []
      that.composeStr()
      if (that.selectIndex == '0') {
        // 按知识点筛选不拼接
        that.getPaperChapterData() // 获取章节树列表
      } else {
        // 知识点接口
        that.getPaperKnowledgesData()
      }
      let str = that.selectTypeFromModel.stageId + ',' + that.selectTypeFromModel.subjectId + ',' + that.selectTypeFromModel.versionId + ',' + that.selectTypeFromModel.bookTypeId
      Cookies.set('filters', str, { expires: 7, path: '/', domain: that.$cookiesDomain })
      that.getQuestionOption()
      that.currentPage = 1
      that.getQuestionsList(that.currentPage)
      that.getShoppingCartList() // 试题篮列表
      that.visible = false
    },
    getQuestionOption() {
      // 获取试题选项
      that.isMore = true
      const loading = this.$loading({
        // 这里不用封装的loading是为了解决loading有点延迟
        lock: true,
        spinner: 'el-icon-loading',
        target: document.querySelector('.manual-main-right-top'),
      })
      let data = {
        stage_id: that.selectTypeFromModel.stageId,
        subject_id: that.selectTypeFromModel.subjectId,
      }
      return new Promise((resolve, reject) => {
        questionOptions(data)
          .then(res => {
            loading.close()
            if (res.code === 200) {
              that.exerciseType = res.data.topic
              that.exerciseBigType = res.data.type
              that.exerciseDifficult = res.data.difficulty
              let obj = {
                id: 0,
                label: '全部',
              }
              that.exerciseType.unshift(obj)
              that.exerciseBigType.unshift(obj)
              that.exerciseDifficult.unshift(obj)
            }
          })
          .catch(err => {
            loading.close()
          })
      })
    },
    getQuestionsList(page, type) {
      // 获取试题列表
      if (!type) {
        that.loadingFlag = true
      }
      let data = {
        stage_id: that.selectTypeFromModel.stageId,
        subject_id: that.selectTypeFromModel.subjectId,
        topic_id: that.exerciseTypeIndex,
        type_id: that.exerciseBigTypeIndex,
        diff_id: that.exerciseDifficultIndex,
        page: page,
        sort: that.exerciseSizeIndex,
      }
      if (that.selectIndex == '0') {
        data.chapters = that.keys
        data.version_id = that.selectTypeFromModel.versionId
        data.book_id = that.selectTypeFromModel.bookTypeId
      } else {
        data.knowledges = that.keys
      }
      return new Promise((resolve, reject) => {
        questionList(data)
          .then(res => {
            that.composeStr() // 避免数据还没加载完成就拼接了字符
            that.loadingFlag = false
            if (res.code === 200) {
              that.exerciseList = res.data.data
              that.total = res.data.total
              that.$nextTick(() => {
                util.setMoreMask(that.exerciseList, that) // 设置更多遮罩
                util.getOptionsWidth(that.exerciseList, that.optsParentWidth, that)
              })
            }
          })
          .catch(err => {
            that.loadingFlag = false
          })
      })
    },
    getShoppingCartList() {
      // 获取购物车列表
      let data = {
        stage_id: that.selectTypeFromModel.stageId,
        subject_id: that.selectTypeFromModel.subjectId,
      }
      return new Promise((resolve, reject) => {
        shoppingCartList(data).then(res => {
          if (res.code === 200) {
            that.shoppingCartList = res.data
          }
        })
      })
    },
    refreshExercisesList(val) {
      //子组件删除触发父组件刷新试题列表
      if (val) {
        that.getQuestionsList(that.currentPage, true)
        that.getShoppingCartList()
      }
    },
    refreshCartList(val) {
      // 试题子组件触发父组件刷新试题篮列表
      if (val) {
        that.getShoppingCartList()
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.manual-container {
  width: 100%;
  .manual-main {
    box-sizing: border-box;
    width: 1200px;
    min-width: 1200px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    .manual-main-top {
      overflow: hidden;
      .el-breadcrumb {
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        color: #808080;
      }
      .el-breadcrumb-float {
        float: left;
      }
    }
    .manual-main-left {
      float: left;
      width: 260px;
      .manual-main-left-top {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        background-color: #fff;
        margin-bottom: 9px;
        span {
          box-sizing: border-box;
          display: inline-block;
          width: 126px;
          height: 100%;
          line-height: 40px;
          text-align: center;
          color: #808080;
          font-size: 14px;
          border-bottom: 2px solid transparent;
          cursor: pointer;
          & > span {
            width: 100%;
            height: 20px;
            line-height: 20px;
            border-bottom: none;
          }
          &:nth-child(2) > span {
            border-left: 1px solid #f2f2f2;
          }
          &.active {
            & > span {
              color: #2b99ff;
              font-weight: bold;
            }
            border-bottom-color: #2b99ff;
          }
        }
      }
      .manual-main-left-middle {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        .selected-type-text {
          box-sizing: border-box;
          display: inline-block;
          font-size: 12px;
          width: 100%;
          height: 100%;
          padding: 0 10px;
          cursor: pointer;
          color: #2b99ff;
          & > span {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 200px;
            vertical-align: bottom;
            font-size: 14px;
          }
        }
      }
      .manual-main-left-bottom {
        box-sizing: border-box;
        width: 100%;
        padding: 10px;
        background-color: #fff;
        min-height: 100px;
        margin-bottom: 30px;
        margin-top: 2px;
        .manual-main-left-bottom-empty {
          width: 100%;
          padding: 30px 0;
          font-size: 12px;
          color: #ccc;
          text-align: center;
        }
      }
    }
    .manual-main-right {
      float: right;
      width: calc(100% - 270px);
      margin-left: 10px;
      .manual-main-right-top {
        box-sizing: border-box;
        display: inline-block;
        width: 100%;
        padding: 0 20px;
        background-color: #fff;
        .manual-main-right-top-item {
          position: relative;
          font-size: 14px;
          overflow: hidden;
          & > span {
            float: left;
            width: 50px;
            height: 100%;
            line-height: 40px;
            text-align: right;
            color: #808080;
            & > a {
              font-size: 12px;
              &:hover {
                color: #2b99ff;
              }
              & > i {
                padding-left: 6px;
              }
            }
          }
          & > .manual-main-right-top-list {
            box-sizing: border-box;
            float: left;
            margin-bottom: 1px;
            width: calc(100% - 100px);
            height: 40px;
            &.fh {
              height: auto;
              margin-bottom: 8px;
            }
            & > li {
              float: left;
              height: 24px;
              cursor: pointer;
              padding: 0 10px;
              text-align: center;
              margin: 9px 20px 0 0;
              line-height: 24px;
              color: #333333;
              border-radius: 2px;
              &.active,
              &:hover {
                color: #fff;
                background-color: #2b99ff;
              }
            }
          }
        }
        .manual-main-right-top-item + .manual-main-right-top-item {
          border-top: 1px solid #f2f2f2;
        }
      }
      .manual-main-right-middle {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        background-color: #fff;
        padding: 7px 20px;
        overflow: hidden;
        margin: 7px 0 10px 0;
        .manual-main-right-size-group {
          float: left;
          & > span {
            float: left;
            box-sizing: border-box;
            padding: 0 12px;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
            border: 1px solid #ccc;
            cursor: pointer;
            color: #808080;
            & > i {
              font-size: 14px;
            }
            &:nth-child(2) {
              margin-left: -1px;
            }
            &.active {
              color: #2b99ff;
            }
          }
        }
        .manual-main-right-totalSize {
          float: right;
          color: #ccc;
          font-size: 14px;
          line-height: 24px;
        }
      }
      .manual-main-right-bottom {
        overflow: hidden;
        background-color: #fff;
        position: relative;
        margin-bottom: 100px;
        .myLoading {
          width: 100%;
          position: absolute;
          top: 130px;
          text-align: center;
          z-index: 999999;
        }
        .manual-main-right-bottom-noEmpty {
          background-color: #f2f2f2;
          .manual-main-right-pageWrap {
            overflow: hidden;
            box-sizing: border-box;
            width: 100%;
            height: 60px;
            background-color: #fff;
            box-sizing: border-box;
          }
        }
        .manual-main-right-empty {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding: 180px 0;
          text-align: center;
          line-height: 30px;
          background-color: #fff;
          & > p {
            font-size: 14px;
            color: #ccc;
            & > i {
              font-size: 70px;
              color: #ccc;
            }
          }
        }
      }
    }
  }
}
.select-type-popover {
  // 选择类型下拉
  box-sizing: border-box;
  margin-top: 16px !important;
  padding: 20px 35px !important;
  .select-type-slot {
    .el-form-item {
      margin-bottom: 16px;
      .el-form-item__label {
        padding: 0 6px 0 0 !important;
      }
    }
    .select-type-slot-btnGroup {
      margin: 25px 0 0 0;
      text-align: center;
      .el-form-item__content {
        margin-left: 0 !important;
        .el-button--medium {
          padding: 10px 25px !important;
        }
      }
    }
  }
}
.shopping-cart-overNum-dialog {
  .el-dialog__header {
    padding: 0;
  }
  p:nth-child(1) {
    color: #f60;
    font-size: 40px;
    text-align: center;
  }
  p:nth-child(2) {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-top: 12px;
    line-height: 24px;
  }
}
</style>
